import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"VueTables__limit-field"},[_c(VSelect,{attrs:{"id":_vm.props.selectAttrs.id,"value":_vm.props.selectAttrs.value,"label":_vm.props.display('limit'),"items":_vm.props.perPageValues},on:{"change":_vm.props.selectEvents.change}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }